"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ripple = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../../../theme/ThemeProvider");

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _ThemeProvider.createUseStyles)({
  Ripple: {
    border: '3px solid #6a6a6a',
    borderRadius: '100%',
    animationName: '$ripple',
    animationDuration: '1s',
    animationDelay: 0,
    animationIterationCount: 'infinite',
    animationPlayState: 'running'
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(0.1)',
      opacity: 0.9
    },
    '100%': {
      transform: 'scale(1)',
      opacity: 0
    }
  }
});

var Ripple = function Ripple(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 20 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 20 : _ref$width,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["height", "width"]);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, rest, {
    className: (0, _classnames["default"])(classes.Ripple, rest.className),
    style: {
      height: height,
      width: width
    }
  }));
};

exports.Ripple = exports["default"] = Ripple;
//# sourceMappingURL=Ripple.js.map